import { useAtom } from "jotai";
import { atomFamily, atomWithStorage, useAtomValue } from "jotai/utils";

import * as flowConfig from "flows/text-mining/config";

const PREFIX = `${flowConfig.FLOW_NAME}/create`;

const overlayToBeShown = atomWithStorage(`${PREFIX}/show-create-overlay`, true);

export const useOverlayStatus = () => useAtom(overlayToBeShown);

export const useGetOverlayDisplay = () => useAtomValue(overlayToBeShown);

const inputFile = atomWithStorage<string>(`${PREFIX}/input-file`, null);

export const useInputFile = () => useAtom(inputFile);

export const useGetInputFile = () => useAtomValue(inputFile);

const textColumns = atomFamily((fileId: string) =>
  atomWithStorage<string[]>(`${PREFIX}/${fileId}/text-columns`, [])
);

export const useTextColumns = () => {
  const fileId = useAtomValue(inputFile);
  return useAtom(textColumns(fileId));
};

export const useGetTextColumns = () => {
  const fileId = useAtomValue(inputFile);
  return useAtomValue(textColumns(fileId));
};

const wordMapperFile = atomWithStorage<string>(
  `${PREFIX}/word-mapper-file`,
  null
);

export const useWordMapperFile = () => useAtom(wordMapperFile);

export const useGetWordMapperFile = () => useAtomValue(wordMapperFile);

const wordMapperKeyColumn = atomFamily((fileId: string) =>
  atomWithStorage<string>(`${PREFIX}/${fileId}/word-mapper-key-column`, null)
);

export const useWordMapperKeyColumn = () => {
  const fileId = useAtomValue(wordMapperFile);
  return useAtom(wordMapperKeyColumn(fileId));
};

export const useGetWordMapperKeyColumn = () => {
  const fileId = useAtomValue(wordMapperFile);
  return useAtomValue(wordMapperKeyColumn(fileId));
};

const wordMapperValueColumn = atomFamily((fileId: string) =>
  atomWithStorage<string>(`${PREFIX}/${fileId}/word-mapper-value-column`, null)
);

export const useWordMapperValueColumn = () => {
  const fileId = useAtomValue(wordMapperFile);
  return useAtom(wordMapperValueColumn(fileId));
};

export const useGetWordMapperValueColumn = () => {
  const fileId = useAtomValue(wordMapperFile);
  return useAtomValue(wordMapperValueColumn(fileId));
};
